import styled from 'styled-components';

const Accordion = styled.section`
  .row {
    font-family: 'Open Sans', sans-serif;
    display: flex;
    flex-direction: column;
    margin-top: 150px;
    width: 100%;
    min-height: 500px;
    border-radius: 20px;
    padding: 40px;
    background-color: #fff;
    color: hsl(292, 42%, 14%);
    box-shadow: 5px 10px 20px rgba(0, 0, 0, 0.2);

    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      box-shadow: 0 0 0 rgba(0, 0, 0, 0.2);
      padding: 0;
      margin-top: 100px;
    }

    h1 {
      font-family: 'Poppins', sans-serif;
      font-size: 2.5rem;
      font-weight: 600;
      margin-bottom: 50px;
      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        text-align: center;
        font-size: 2rem;
      }
    }

    .accordion {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      grid-column-gap: 30px;

      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        grid-template-columns: 1fr;
      }

      .accordion-items {
        position: relative;
        border-bottom: 1px solid #d3d3d3;
        padding-bottom: 30px;
        margin-bottom: 25px;

        &:hover {
          cursor: pointer;
        }

        .accordionButton {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          background: transparent;
          border: none;
          text-decoration: none;
          font-size: 16px;
          color: #000;
          font-weight: bold;
          cursor: pointer;
          text-align: left;
          padding: 0;

          h3 {
            line-height: 1.3;
            font-weight: 200;
            font-size: 1.2rem;
            width: 90%;
            opacity: 0.6;
          }

          &:focus {
            outline: none;
          }
        }

        .iconWrapper {
          position: relative;
          width: 40px;
          height: 40px;

          .btn {
            position: absolute;
            top: 0;
            right: 0;
            width: 15px;
            height: 15px;
            transition: opacity 0.3s ease;
            border: 0.5px solid ${(props) => props.theme.color.lightBlue};
            border-radius: 50%;
            padding: 10px;
            color: ${(props) => props.theme.color.lightBlue};
          }

          .hidden {
            opacity: 0;
            pointer-events: none;
          }
        }
      }
    }
  }
`;
const TransportChallengesAccordion = styled.section`
  .row {
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 500px;
    border-radius: 20px;
    padding: 40px;
    background-color: #fff;
    color: hsl(292, 42%, 14%);

    h1 {
      margin-bottom: 50px;
    }

    .accordion {
      display: grid;
      // grid-template-columns: repeat(2, minmax(0, 1fr));
      grid-column-gap: 20px;

      .accordion-items {
        position: relative;
        border-bottom: 1px solid #d3d3d3;
        padding-bottom: 30px;
        margin-bottom: 25px;

        &:hover {
          cursor: pointer;
        }

        .accordionButton {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          background: transparent;
          border: none;
          font-size: 1.4rem;
          font-weight: bold;
          cursor: pointer;
          text-align: left;
          padding: 0;

          h3 {
            font-size: 1.3rem;
            font-weight: 400;
            opacity: 0.6;
            width: 80%;
          }

          &:focus {
            outline: none;
          }
        }

        .iconWrapper {
          position: relative;
          width: 40px;
          height: 40px;

          .btn {
            position: absolute;
            top: 0;
            right: 0;
            width: 15px;
            height: 15px;
            transition: opacity 0.3s ease;
            border: 0.5px solid ${(props) => props.theme.color.lightBlue};
            border-radius: 50%;
            padding: 10px;
            color: ${(props) => props.theme.color.lightBlue};
          }

          .hidden {
            opacity: 0;
            pointer-events: none;
          }
        }
      }
    }
  }
`;

const AccordionContent = styled.div`
  max-height: ${({ isOpen }) => (isOpen ? '200px' : '0')};
  overflow: hidden;
  transition: max-height 0.3s ease;
  // padding: ${({ isOpen }) => (isOpen ? '10px 0' : '0 15px')};
  font-size: 14px;
  color: #555;

  p {
    padding-top: 10px;
    font-size: 0.9rem;
    line-height: 1.5;

    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      font-size: 1rem;
    }
  }
`;

export { Accordion, AccordionContent, TransportChallengesAccordion };
